import { useToastState, Toast } from '@tamagui/toast';
import { YStack, XStack, Text } from 'tamagui';

export const CurrentToast = () => {
  const toast = useToastState();
  if (!toast || toast.isHandledNatively) return null;
  return (
    <Toast
      key={toast.id}
      duration={toast.duration}
      backgroundColor={toast.backgroundColor || '#1CC83A'}
      borderRadius="$9"
      padding="$5"
      minWidth={300}
      animation="200ms"
      enterStyle={{ opacity: 0, transform: [{ translateY: 100 }] }}
      exitStyle={{ opacity: 0, transform: [{ translateY: 100 }] }}
      transform={[{ translateY: 0 }]}
      viewportName={toast.viewportName}>
      <XStack alignItems="center" gap="$5">
        {toast.icon}
        <YStack>
          <Text color="$black2" fontSize="$9" fontWeight="700">
            {toast.title}
          </Text>
          {toast.message && (
            <Text color="$black2" fontSize="$8.5">
              {toast.message}
            </Text>
          )}
        </YStack>
      </XStack>
    </Toast>
  );
};
